import React from "react";
import { ColorOptions } from "../../../types/colorOptions";

export interface LinkProps {
    label: string;
    url?: string;
    icon?: React.ReactNode;
    className?: string;
    options?: ColorOptions;
}

export const Link = ({ label, url, icon, className }: LinkProps) => {
    return (
        <a href={url} className={className}>
            {icon && <span>{icon}</span>}
            {label}
        </a>
    );
};
